var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"site-footer"},[_c('div',{staticClass:"copyright"},[_vm._v("2019@miracle-All rights reserved."),_c('br'),_vm._v("Copyright by 米洛科技網頁設計")])])
}]

export { render, staticRenderFns }